import { Button, Modal, TextInput } from '@mantine/core'
// import { Libraries } from '@react-google-maps/api'
import {
	APIProvider,
	ControlPosition,
	Map,
	Marker,
	useMapsLibrary,
} from '@vis.gl/react-google-maps'
import { useEffect, useRef, useState } from 'react'
import axiosInstance from '../../config/axios.config.ts'
import secretKeys from '../../config/configVariables.ts'
import Colors from '../../constants/colors.ts'
import { IAuthUserResponse } from '../../interfaces/account/IAuthUserResponse.ts'
import { IAddressResponse } from '../../interfaces/geocods/IAddressResponse.ts'
import { IAddressSuggestionsResponse } from '../../interfaces/geocods/IAddressSuggestionsResponse.ts'
import { setNavbarAddress } from '../../store/account/accountSlice.ts'
import {
	getGeoCodeAddress,
	getGeoCodeAutoComplete,
} from '../../store/product/productActions.ts'
import { useAppDispatch } from '../../store/store.ts'
import { notificationSystem } from '../../utils/notificationSystem.ts'
import { getUser, setAuthUser, setLocation } from '../../utils/storage.ts'
import { AutoCompleteMap } from '../map/auto-complete/AutoCompleteMap.tsx'
import {
	AutocompleteMode,
	CustomMapControl,
} from '../map/auto-complete/MapControl.tsx'
import MapHandler from '../map/auto-complete/MapHandler.tsx'
import './map.css'

type MapModalProps = {
	opened: boolean
	close: () => void
}

type MapProps = {
	lat: number
	lng: number
}

const autocompleteModes: Array<AutocompleteMode> = [
	{ id: 'classic', label: 'Google Autocomplete Widget' },
	{ id: 'custom', label: 'Custom Build' },
	{ id: 'custom-hybrid', label: 'Custom w/ Select Widget' },
]

const MapModal = ({ opened, close }: MapModalProps) => {
	const currentUser = getUser()

	const [center, setCenter] = useState<MapProps>({
		lat: currentUser?.address?.latitude ?? 0,
		lng: currentUser?.address?.longitude ?? 0,
	})

	// const { address } = useAppSelector((state) => state.account)
	const [currentAddress, setCurrentAddress] = useState(
		currentUser?.address?.formattedAddress
	)
	const dispatch = useAppDispatch()

	const [selectedPlace, setSelectedPlace] =
		useState<google.maps.places.PlaceResult | null>(null)
	const [loading, setLoading] = useState(false)
	const apiKey = secretKeys.MAP_API_KEY

	const [placeAutocomplete, setPlaceAutocomplete] =
		useState<google.maps.places.Autocomplete | null>(null)
	const inputRef = useRef<HTMLInputElement>(null)
	const places = useMapsLibrary('places')

	const handlePlaceSelect = (place: google.maps.places.PlaceResult | null) => {
		if (place) {
			// console.log('Selected Place:', place)
			// Add any logic to handle the selected place here

			try {
				const location = place?.geometry?.location
				// console.log(`location`, place?.geometry)

				if (!location) return

				const lat = location.lat()
				const lng = location.lng()

				// ✅ Get place_id
				const placeId = place.place_id
				console.log('Place ID:', placeId)

				console.log(`lat: ${lat}, lng: ${lng}`)

				setCenter({
					lat: lat,
					lng: lng,
				})

				setLocation({
					lat: lat,
					lng: lng,
				})
				dispatch(setNavbarAddress(place.formatted_address))
				setCurrentAddress(place.formatted_address || '')

				console.log('address by input', place.formatted_address)
			} catch (error) {
				console.error('Geocoder failed due to: ', error)
			}
		}
	}

	useEffect(() => {
		if (!places || !inputRef.current) return

		const options = {
			fields: ['geometry', 'name', 'formatted_address'],
		}

		setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options))
	}, [places])

	useEffect(() => {
		if (!placeAutocomplete) return

		placeAutocomplete.addListener('place_changed', () => {
			handlePlaceSelect(placeAutocomplete.getPlace())
		})
	}, [placeAutocomplete])

	const handleSubmit = async () => {
		setLoading(true)

		if (!currentAddress) {
			setLoading(false)
			notificationSystem('Please enter a valid address', '', true)
			return
		}
		await dispatch(getGeoCodeAutoComplete(currentAddress)).then((action) => {
			const payload = (action as { payload?: IAddressSuggestionsResponse })
				.payload

			if (payload?.success && payload.response.length > 0) {
				const matchedResult = payload.response.find(
					(item) =>
						item.description.toLowerCase() === currentAddress.toLowerCase()
				)
				if (matchedResult) {
					console.log('Matched place_id:', matchedResult.place_id) // find the place_id
					dispatch(getGeoCodeAddress(matchedResult.place_id)).then((action) => {
						const payload = (action as { payload?: IAddressResponse }).payload

						console.log(`I Address `, payload)
						setAuthUser({ ...currentUser, address: payload?.response }) // update address locally

						// updating profile

						const data = {
							personalAddress: payload?.response,
						}

						const res = axiosInstance.put<IAuthUserResponse>('auth', {
							personalInformation: data,
						})

						res
							.then((res) => {
								console.log('Address updated successfully', res.data)
							})
							.catch((error) => {
								console.error('Error updating address:', error)
							})
					})
				} else {
					console.log('No exact match found for currentAddress')
				}
			} else {
				console.log('No suggestions available or failed to fetch')
			}
		})

		dispatch(setNavbarAddress(currentAddress))

		setLoading(false)
		notificationSystem('Address Update Successfully', '', false)
		close()
	}

	return (
		<Modal
			radius='lg'
			centered
			size='xl'
			title='Add new address'
			opened={opened}
			onClose={close}
			h={'max-content'}
		>
			<APIProvider apiKey={apiKey}>
				<>
					<TextInput
						ref={inputRef}
						value={currentAddress}
						onChange={(e) => {
							setCurrentAddress(e.target.value)
						}}
						my='sm'
						size='lg'
						radius='lg'
						fw={400}
					/>

					<Map
						zoomControl={true}
						// mapId={'bf51a910020fa25a'}
						// mapTypeId='roadmap'

						defaultZoom={14}
						center={{
							lat: center?.lat || 0,
							lng: center?.lng || 0,
						}}
						gestureHandling={'greedy'}
						style={{
							height: '400px',
							width: '100%',
							borderRadius: '20px',
							marginBottom: '20px',
						}}
						disableDefaultUI={false}
						disableDoubleClickZoom={false}
					>
						<CustomMapControl
							controlPosition={ControlPosition.TOP}
							selectedAutocompleteMode={autocompleteModes[0]}
							onPlaceSelect={setSelectedPlace}
						/>
						<AutoCompleteMap
							inputRef={inputRef}
							onPlaceSelect={handlePlaceSelect}
						/>
						<MapHandler place={selectedPlace} />

						<Marker position={{ lat: center.lat, lng: center.lng }} />
					</Map>
				</>
			</APIProvider>

			<Button
				onClick={() => {
					handleSubmit()
				}}
				loading={loading}
				component='a'
				my='sm'
				fw={400}
				size='lg'
				radius='xl'
				w='100%'
				c={'white'}
				mt={10}
				color={Colors.primaryColor}
				autoContrast
			>
				Save Address
			</Button>
		</Modal>
	)
}

export default MapModal
